import { v4 as uuidv4 } from 'uuid';

// Simulated delay for API calls
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Dummy betting items
const bettingItems = [
  {
    id: uuidv4(),
    name: 'Cash Prize',
    description: 'Win up to KES 10,000 in cash!',
    image: '💰',
    minPrize: 'KES 50',
    maxPrize: 'KES 10,000',
    cost: 20,
    category: 'cash'
  },
  {
    id: uuidv4(),
    name: 'Luxury Car',
    description: 'Drive away in a brand new car!',
    image: '🚗',
    minPrize: 'Car Accessory',
    maxPrize: 'Toyota Prado',
    cost: 20,
    category: 'vehicle'
  },
  {
    id: uuidv4(),
    name: 'Smartphone',
    description: 'Win the latest flagship phones!',
    image: '📱',
    minPrize: 'Phone Case',
    maxPrize: 'iPhone 15 Pro',
    cost: 20,
    category: 'electronics'
  },
  {
    id: uuidv4(),
    name: 'Mega Jackpot',
    description: 'The ultimate prize pool awaits!',
    image: '🎰',
    minPrize: 'KES 100',
    maxPrize: 'KES 1,000,000',
    cost: 20,
    category: 'jackpot'
  },
  {
    id: uuidv4(),
    name: 'Electronics Bundle',
    description: 'Win laptops, TVs, and more!',
    image: '💻',
    minPrize: 'Earbuds',
    maxPrize: 'MacBook Pro',
    cost: 20,
    category: 'electronics'
  },
  {
    id: uuidv4(),
    name: 'Shopping Voucher',
    description: 'Shop till you drop!',
    image: '🛍️',
    minPrize: 'KES 500 Voucher',
    maxPrize: 'KES 50,000 Voucher',
    cost: 20,
    category: 'voucher'
  }
];

// Generate random box contents based on item category
const generateBoxContents = (category) => {
  const contents = {
    cash: [
      { prize: 'KES 50', isWin: false, tier: 'consolation' },
      { prize: 'KES 100', isWin: true, tier: 'small' },
      { prize: 'KES 500', isWin: true, tier: 'medium' },
      { prize: 'KES 1,000', isWin: true, tier: 'good' },
      { prize: 'KES 5,000', isWin: true, tier: 'great' },
      { prize: 'KES 10,000', isWin: true, tier: 'jackpot' },
      { prize: 'Try Again', isWin: false, tier: 'loss' }
    ],
    vehicle: [
      { prize: 'Car Freshener', isWin: false, tier: 'consolation' },
      { prize: 'Fuel Voucher KES 500', isWin: true, tier: 'small' },
      { prize: 'Car Service Voucher', isWin: true, tier: 'medium' },
      { prize: 'Motorcycle', isWin: true, tier: 'good' },
      { prize: 'Toyota Vitz', isWin: true, tier: 'great' },
      { prize: 'Toyota Prado', isWin: true, tier: 'jackpot' },
      { prize: 'Try Again', isWin: false, tier: 'loss' }
    ],
    electronics: [
      { prize: 'Phone Case', isWin: false, tier: 'consolation' },
      { prize: 'Wireless Earbuds', isWin: true, tier: 'small' },
      { prize: 'Smart Watch', isWin: true, tier: 'medium' },
      { prize: 'iPad Mini', isWin: true, tier: 'good' },
      { prize: 'MacBook Air', isWin: true, tier: 'great' },
      { prize: 'iPhone 15 Pro Max', isWin: true, tier: 'jackpot' },
      { prize: 'Try Again', isWin: false, tier: 'loss' }
    ],
    jackpot: [
      { prize: 'KES 100', isWin: false, tier: 'consolation' },
      { prize: 'KES 1,000', isWin: true, tier: 'small' },
      { prize: 'KES 10,000', isWin: true, tier: 'medium' },
      { prize: 'KES 50,000', isWin: true, tier: 'good' },
      { prize: 'KES 500,000', isWin: true, tier: 'great' },
      { prize: 'KES 1,000,000', isWin: true, tier: 'jackpot' },
      { prize: 'Try Again', isWin: false, tier: 'loss' }
    ],
    voucher: [
      { prize: 'KES 100 Voucher', isWin: false, tier: 'consolation' },
      { prize: 'KES 500 Voucher', isWin: true, tier: 'small' },
      { prize: 'KES 2,000 Voucher', isWin: true, tier: 'medium' },
      { prize: 'KES 10,000 Voucher', isWin: true, tier: 'good' },
      { prize: 'KES 25,000 Voucher', isWin: true, tier: 'great' },
      { prize: 'KES 50,000 Voucher', isWin: true, tier: 'jackpot' },
      { prize: 'Try Again', isWin: false, tier: 'loss' }
    ]
  };

  // Shuffle the contents for randomness
  const categoryContents = contents[category] || contents.cash;
  return [...categoryContents].sort(() => Math.random() - 0.5);
};

// Store for simulated betting history
let bettingHistory = [
  // Pre-populated dummy history
  {
    id: uuidv4(),
    phoneNumber: '0712345678',
    itemId: bettingItems[0].id,
    itemName: 'Cash Prize',
    itemImage: '💰',
    boxChosen: 3,
    result: { prize: 'KES 500', isWin: true, tier: 'medium' },
    allBoxContents: generateBoxContents('cash'),
    winningBox: 3,
    timestamp: new Date(Date.now() - 86400000).toISOString(),
    cost: 20
  },
  {
    id: uuidv4(),
    phoneNumber: '0712345678',
    itemId: bettingItems[1].id,
    itemName: 'Luxury Car',
    itemImage: '🚗',
    boxChosen: 5,
    result: { prize: 'Try Again', isWin: false, tier: 'loss' },
    allBoxContents: generateBoxContents('vehicle'),
    winningBox: 2,
    timestamp: new Date(Date.now() - 172800000).toISOString(),
    cost: 20
  },
  {
    id: uuidv4(),
    phoneNumber: '0712345678',
    itemId: bettingItems[2].id,
    itemName: 'Smartphone',
    itemImage: '📱',
    boxChosen: 1,
    result: { prize: 'Smart Watch', isWin: true, tier: 'medium' },
    allBoxContents: generateBoxContents('electronics'),
    winningBox: 1,
    timestamp: new Date(Date.now() - 259200000).toISOString(),
    cost: 20
  },
  {
    id: uuidv4(),
    phoneNumber: '0798765432',
    itemId: bettingItems[3].id,
    itemName: 'Mega Jackpot',
    itemImage: '🎰',
    boxChosen: 6,
    result: { prize: 'KES 50,000', isWin: true, tier: 'good' },
    allBoxContents: generateBoxContents('jackpot'),
    winningBox: 6,
    timestamp: new Date(Date.now() - 345600000).toISOString(),
    cost: 20
  }
];

/**
 * Fetch all available betting items
 * @returns {Promise<Array>} List of betting items
 */
export const fetchBettingItems = async () => {
  await delay(800);
  return [...bettingItems];
};

/**
 * Fetch a single betting item by ID
 * @param {string} itemId - The item ID
 * @returns {Promise<Object|null>} The betting item or null
 */
export const fetchBettingItem = async (itemId) => {
  await delay(300);
  return bettingItems.find(item => item.id === itemId) || null;
};

/**
 * Initiate a new bet
 * @param {string} itemId - The betting item ID
 * @param {number} boxNumber - The chosen box (1-7)
 * @param {string} phoneNumber - User's phone number
 * @returns {Promise<Object>} Bet initiation result
 */
export const initiateBet = async (itemId, boxNumber, phoneNumber) => {
  await delay(1500); // Simulate payment processing
  
  const item = bettingItems.find(i => i.id === itemId);
  if (!item) {
    throw new Error('Invalid betting item');
  }

  const betId = uuidv4();
  const allBoxContents = generateBoxContents(item.category);
  const result = allBoxContents[boxNumber - 1];
  
  // Create the bet record
  const betRecord = {
    id: betId,
    phoneNumber,
    itemId,
    itemName: item.name,
    itemImage: item.image,
    boxChosen: boxNumber,
    result,
    allBoxContents,
    winningBox: allBoxContents.findIndex(box => box.tier === 'jackpot') + 1,
    timestamp: new Date().toISOString(),
    cost: item.cost
  };

  // Store in history
  bettingHistory.unshift(betRecord);

  return {
    success: true,
    betId,
    message: 'Payment received successfully via M-Pesa',
    transactionId: `MP${Date.now()}`,
    phoneNumber
  };
};

/**
 * Fetch the result of a specific bet
 * @param {string} betId - The bet ID
 * @returns {Promise<Object>} Detailed bet result
 */
export const fetchBetResult = async (betId) => {
  await delay(500);
  
  const bet = bettingHistory.find(b => b.id === betId);
  if (!bet) {
    throw new Error('Bet not found');
  }

  return {
    betId: bet.id,
    itemName: bet.itemName,
    itemImage: bet.itemImage,
    boxChosen: bet.boxChosen,
    winningBox: bet.winningBox,
    result: bet.result,
    allBoxContents: bet.allBoxContents,
    timestamp: bet.timestamp,
    isWinner: bet.result.isWin
  };
};

/**
 * Fetch betting history for a phone number
 * @param {string} phoneNumber - User's phone number
 * @returns {Promise<Array>} List of past bets
 */
export const fetchBettingHistory = async (phoneNumber) => {
  await delay(1000);
  
  // Normalize phone number (remove leading 0 or +254)
  const normalizedPhone = phoneNumber.replace(/^(\+254|254|0)/, '0');
  
  const history = bettingHistory.filter(bet => {
    const betPhone = bet.phoneNumber.replace(/^(\+254|254|0)/, '0');
    return betPhone === normalizedPhone;
  });

  return history.map(bet => ({
    id: bet.id,
    itemName: bet.itemName,
    itemImage: bet.itemImage,
    boxChosen: bet.boxChosen,
    result: bet.result,
    allBoxContents: bet.allBoxContents,
    winningBox: bet.winningBox,
    timestamp: bet.timestamp,
    cost: bet.cost,
    isWinner: bet.result.isWin
  }));
};

/**
 * Validate phone number format (Kenyan)
 * @param {string} phoneNumber - Phone number to validate
 * @returns {boolean} Whether the phone number is valid
 */
export const validatePhoneNumber = (phoneNumber) => {
  // Kenyan phone number patterns
  const patterns = [
    /^0[17]\d{8}$/,      // 0712345678, 0798765432
    /^\+254[17]\d{8}$/,  // +254712345678
    /^254[17]\d{8}$/     // 254712345678
  ];
  
  return patterns.some(pattern => pattern.test(phoneNumber));
};

/**
 * Simulate STK Push for M-Pesa payment
 * @param {string} phoneNumber - User's phone number
 * @param {number} amount - Amount to charge
 * @returns {Promise<Object>} STK Push result
 */
export const simulateSTKPush = async (phoneNumber, amount) => {
  await delay(2000); // Simulate network delay
  
  return {
    success: true,
    checkoutRequestId: `ws_CO_${Date.now()}`,
    merchantRequestId: `MR${Date.now()}`,
    responseDescription: 'Success. Request accepted for processing',
    customerMessage: `Please enter your M-Pesa PIN to complete payment of KES ${amount}`
  };
};

export default {
  fetchBettingItems,
  fetchBettingItem,
  initiateBet,
  fetchBetResult,
  fetchBettingHistory,
  validatePhoneNumber,
  simulateSTKPush
};

